import api from './axiosConfig';

export const subscriptionApi = {
  // Get all plans (public)
  getPlans: () => api.get('/v1/subscription/plans'),

  // Get current user's subscription
  getCurrentPlan: () => api.get('/v1/subscription/current'),

  // Get usage stats
  getUsageStats: () => api.get('/v1/subscription/usage'),

  // Get payment history
  getPaymentHistory: () => api.get('/v1/subscription/history'),

  // Create Razorpay order
  createRazorpayOrder: (planSlug, billingCycle = 'monthly') => 
    api.post('/v1/subscription/razorpay/order', { planSlug, billingCycle }),

  // Verify Razorpay payment
  verifyRazorpayPayment: (paymentData) =>
    api.post('/v1/subscription/razorpay/verify', paymentData),

  // Cancel subscription
  cancelSubscription: () => api.post('/v1/subscription/cancel'),
};
